class FarloUiTicketCalendar {
	constructor(element, _config) {
		this.container = element;
		this.options = _config;
		this.minDate = new Date(this.container.dataset.startMonth + 'T12:00:00');
		this.maxDate = new Date(this.container.dataset.endMonth + 'T12:00:00');
		this.startDay = this.container.dataset.startDay === 'monday' ? 1 : 0; // 1 for Monday, 0 for Sunday
		this.currentDate = new Date(this.container.dataset.startMonth + 'T12:00:00');
		this.cache = {};

		this.availabilityKey = [];
		if (this.container.dataset.availabilityKey) {
		try {
			this.availabilityKey = JSON.parse(this.container.dataset.availabilityKey);
		} catch (e) {
			console.error('Invalid availability key JSON:', e);
		}
		}

		// slug → colour map
		this.availabilityMap = {};
		this.availabilityKey.forEach(item => {
		const key = item.slug || item.availability;
		if (key && item.colour) {
			this.availabilityMap[key] = item.colour;
		}
		});

		this.castKey = [];
		if (this.container.dataset.castKey) {
			try {
				this.castKey = JSON.parse(this.container.dataset.castKey);
			} catch (e) {
				console.error('Invalid cast key JSON:', e);
			}
		}

		// If ?month=YYYY-MM is in the URL, open that month (clamped to valid range)
		const monthParam = new URLSearchParams(window.location.search).get('month');
		if (monthParam) {
			const paramDate = new Date(monthParam + '-01T12:00:00');
			if (!isNaN(paramDate) && paramDate >= this.minDate && paramDate <= this.maxDate) {
				this.currentDate = paramDate;
			}
		}

		this.render();
	}

	renderHeader() {
		const header = document.createElement('div');
		header.classList.add('farlo-ui-ticket-calendar__header');

		const title = document.createElement('h2');
		title.classList.add('farlo-ui-ticket-calendar__header-month-year');
		title.textContent = this.currentDate.toLocaleDateString(undefined, {
			year: 'numeric',
			month: 'long'
		});
		header.appendChild(title);

		const prevButton = document.createElement('button');
		prevButton.classList.add('farlo-ui-ticket-calendar__button', 'farlo-ui-ticket-calendar__button--prev');
		prevButton.textContent = '<';

		if (this.currentDate > this.minDate) {
			prevButton.classList.remove('farlo-ui-ticket-calendar__button-disabled');
			prevButton.addEventListener('click', () => this.prevMonth());
		} else {
			prevButton.classList.add('farlo-ui-ticket-calendar__button-disabled');
		}

		header.appendChild(prevButton);

		const nextButton = document.createElement('button');
		nextButton.classList.add('farlo-ui-ticket-calendar__button', 'farlo-ui-ticket-calendar__button--next');
		nextButton.textContent = '>';

		if (this.currentDate < this.maxDate) {
			nextButton.classList.remove('farlo-ui-ticket-calendar__button-disabled');
			nextButton.addEventListener('click', () => this.nextMonth());
		} else {
			nextButton.classList.add('farlo-ui-ticket-calendar__button-disabled');
		}

		header.appendChild(nextButton);
		this.container.appendChild(header);
	}

	renderKey() {
		if (!this.availabilityKey || !this.availabilityKey.length) {
			return;
		}

		const legend = document.createElement('div');
		legend.classList.add('farlo-ui-ticket-calendar__key');

		this.availabilityKey.forEach(item => {
			if (!item.availability) return;

			const legendItem = document.createElement('div');
			legendItem.classList.add('farlo-ui-ticket-calendar__key-item');

			const swatch = document.createElement('span');
			swatch.classList.add('farlo-ui-ticket-calendar__key-swatch');
			if (item.colour) {
				swatch.style.backgroundColor = item.colour;
			}

			const label = document.createElement('span');
			label.classList.add('farlo-ui-ticket-calendar__key-label');
			label.textContent = item.availability;

			legendItem.appendChild(swatch);
			legendItem.appendChild(label);
			legend.appendChild(legendItem);
		});

		this.container.appendChild(legend);
	}

	renderDaysOfTheWeeks() {
		const div = document.createElement('div');
		div.classList.add('farlo-ui-ticket-calendar__weeks');

		const daysLetters = this.startDay === 1
			? ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
			: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

		for (let i = 0; i < 7; i++) {
			const days = document.createElement('div');
			days.classList.add('farlo-ui-ticket-calendar__week-day');
			days.textContent = daysLetters[i];
			div.appendChild(days);
		}

		this.container.appendChild(div);
	}

	async fetchEventsForMonth(y, m) {
		const cacheKey = `${y}-${m}`;
		if (this.cache[cacheKey]) {
			this.renderCalendar(this.cache[cacheKey]);
			return;
		}

		const data = new URLSearchParams({
			action: 'getEventsForMonth',
			nonce: farloAjaxVendorHandler.nonce,
			month: m,
			year: y
		});

		this.container.classList.add('farlo-ui-ticket-calendar--loading');

		try {
			const response = await fetch(farloAjaxVendorHandler.ajaxurl, {
				method: 'POST',
				body: data,
				headers: {
					'Accept': 'application/json',
					'Content-type': 'application/x-www-form-urlencoded',
					'X-WP-Nonce': farloAjaxVendorHandler.nonce
				}
			});

			if (response.ok) {
				const responseData = await response.json();
				this.cache[cacheKey] = responseData.data.calendarCells;
				this.cacheMultiMonthData(responseData.data.multiMonthData);
				this.container.classList.remove('farlo-ui-ticket-calendar--loading');
				this.renderCalendar(this.cache[cacheKey]);
			} else {
				console.error('Response status not OK:', response.status);
			}
		} catch (error) {
			console.error('There was an error!', error);
		}
	}

	cacheMultiMonthData(multiMonthData) {
		for (const [key, value] of Object.entries(multiMonthData)) {
			if (!this.cache[key]) {
				this.cache[key] = value;
			}
		}
	}

	applyCastMemberColours() {
		if (!this.castKey || !this.castKey.length) return;

		// Build slug → cast entry map
		const slugMap = {};
		this.castKey.forEach(cast => {
			if (cast.slug) slugMap[cast.slug] = cast;
		});

		const days = this.container.querySelectorAll('.farlo-ui-ticket-calendar__days-day[rel]');
		days.forEach(day => {
			const rel = day.getAttribute('rel'); // Y-m-d
			let castEntry = null;

			// Per-event override takes priority
			const castMemberSlug = day.dataset.castMember;
			if (castMemberSlug && slugMap[castMemberSlug]) {
				castEntry = slugMap[castMemberSlug];
			} else {
				// Fall back to global date-range matching
				castEntry = this.castKey.find(cast =>
					cast.date_from && cast.date_to && rel >= cast.date_from && rel <= cast.date_to
				) || null;
				// Tag the day so hover-dimming works for date-range days too
				if (castEntry && castEntry.slug) {
					day.dataset.castMember = castEntry.slug;
				}
			}

			if (castEntry && castEntry.colour) {
				day.style.backgroundColor = castEntry.colour;
				day.style.borderColor = castEntry.colour;
				this._addCastInfoIcon(day, castEntry.name);
			}
		});
	}

	_addCastInfoIcon(day, castName) {
		if (!castName) return;
		if (day.classList.contains('farlo-ui-ticket-calendar__days-day--past')) return;
		if (!day.querySelector('.farlo-ui-ticket-calendar__days-link')) return;
		const dateSpan = day.querySelector('.farlo-ui-ticket-calendar__days-date');
		if (!dateSpan || dateSpan.querySelector('.farlo-ui-ticket-calendar__cast-info')) return;

		const icon = document.createElement('span');
		icon.classList.add('farlo-ui-ticket-calendar__cast-info');

		const tooltip = document.createElement('span');
		tooltip.classList.add('farlo-ui-ticket-calendar__cast-tooltip');
		tooltip.innerHTML = `<span>Starring</span>${castName}`;
		icon.appendChild(tooltip);

		dateSpan.appendChild(icon);
	}

	renderCastKey(target = this.container) {
		if (!this.castKey || !this.castKey.length) return;

		const legend = document.createElement('div');
		legend.classList.add('farlo-ui-ticket-calendar__cast-key');

		const dimOthers = (slug) => {
			this.container.querySelectorAll('.farlo-ui-ticket-calendar__days-day[data-cast-member]').forEach(day => {
				if (day.dataset.castMember !== slug) {
					day.classList.add('farlo-ui-ticket-calendar__days-day--dimmed');
				}
			});
		};

		const clearDim = () => {
			this.container.querySelectorAll('.farlo-ui-ticket-calendar__days-day--dimmed').forEach(day => {
				day.classList.remove('farlo-ui-ticket-calendar__days-day--dimmed');
			});
		};

		this.castKey.forEach(cast => {
			if (!cast.name) return;

			const item = document.createElement('div');
			item.classList.add('farlo-ui-ticket-calendar__cast-key-item');
			item.dataset.castSlug = cast.slug || '';

			const swatch = document.createElement('span');
			swatch.classList.add('farlo-ui-ticket-calendar__cast-key-swatch');
			if (cast.colour) {
				swatch.style.color = cast.colour;
				swatch.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
									<rect width="16" height="16" fill="currentColor"/>
									<rect x="1" y="10" width="14" height="4" fill="#F7E3CE"/>
									<rect x="1" y="5" width="14" height="4" fill="#F7E3CE"/>
									<rect x="1" y="1" width="2" height="2" fill="#F7E3CE"/>
									</svg> Starring:`;
			}

			const label = document.createElement('span');
			label.classList.add('farlo-ui-ticket-calendar__cast-key-label');
			label.textContent = cast.name;

			item.appendChild(swatch);
			item.appendChild(label);

			// Desktop: hover
			item.addEventListener('mouseenter', () => dimOthers(cast.slug));
			item.addEventListener('mouseleave', () => clearDim());

			// Mobile: tap to toggle, tap again or tap outside to clear
			item.addEventListener('touchstart', (e) => {
				e.stopPropagation();
				if (this._activeCastSlug === cast.slug) {
					this._activeCastSlug = null;
					clearDim();
				} else {
					this._activeCastSlug = cast.slug;
					clearDim();
					dimOthers(cast.slug);
				}
			}, { passive: true });

			legend.appendChild(item);
		});

		// Tap anywhere outside the cast key clears the active state on mobile
		document.addEventListener('touchstart', (e) => {
			if (this._activeCastSlug && !legend.contains(e.target)) {
				this._activeCastSlug = null;
				clearDim();
			}
		}, { passive: true });

		target.appendChild(legend);
	}

	applyAvailabilityColours() {
		if (!this.availabilityMap) return;

		// All event links that have a data-availability attribute
		const elements = this.container.querySelectorAll('.farlo-ui-ticket-calendar__days-link[data-availability]');

		elements.forEach(el => {
			const key = el.dataset.availability;
			const colour = this.availabilityMap[key];

			if (colour) {
			// Use css var + class, so you can style however you like in CSS
			el.style.setProperty('--farlo-availability-colour', colour);
			el.classList.add('farlo-ui-ticket-calendar__days-link--has-availability');

			// If you prefer direct styles instead:
			// el.style.borderLeft = `4px solid ${colour}`;
			}
		});
		}

	renderCalendar(calendarCells) {
		this.container.innerHTML = '';
		this.renderHeader();
		this.renderKey();

		const body = document.createElement('div');
		body.classList.add('farlo-ui-ticket-calendar__body');

		const weeksWrapper = document.createElement('div');
		weeksWrapper.classList.add('farlo-ui-ticket-calendar__weeks');

		const weekDays = document.createElement('div');
		weekDays.classList.add('farlo-ui-ticket-calendar__week-days');
		const daysLetters = this.startDay === 1
			? ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
			: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
		daysLetters.forEach(letter => {
			const d = document.createElement('div');
			d.classList.add('farlo-ui-ticket-calendar__week-day');
			d.textContent = letter;
			weekDays.appendChild(d);
		});
		weeksWrapper.appendChild(weekDays);

		const daysContainer = document.createElement('div');
		daysContainer.classList.add('farlo-ui-ticket-calendar__days');
		if (calendarCells !== '') {
			daysContainer.insertAdjacentHTML('beforeend', calendarCells);
		}
		weeksWrapper.appendChild(daysContainer);

		this.renderCastKey(body);
		body.appendChild(weeksWrapper);
		this.container.appendChild(body);
		this.applyAvailabilityColours();
		this.applyCastMemberColours();
	}

	async render() {
		this.container.innerHTML = '';
		this.renderHeader();
		this.renderKey();

		const body = document.createElement('div');
		body.classList.add('farlo-ui-ticket-calendar__body');
		this.container.appendChild(body);

		await this.fetchEventsForMonth(
			this.currentDate.getFullYear(),
			this.currentDate.getMonth() + 1
		);
	}

	_updateUrlParam() {
		const y = this.currentDate.getFullYear();
		const m = String(this.currentDate.getMonth() + 1).padStart(2, '0');
		const url = new URL(window.location);
		url.searchParams.set('month', `${y}-${m}`);
		history.replaceState(null, '', url);
	}

	prevMonth() {
		this.currentDate.setMonth(this.currentDate.getMonth() - 1);
		this._updateUrlParam();
		this.render();
	}

	nextMonth() {
		this.currentDate.setMonth(this.currentDate.getMonth() + 1);
		this._updateUrlParam();
		this.render();
	}

	handleEventClick(event) {
		if (this.options.eventClick) {
			this.options.eventClick(event);
		}
	}
}

export default FarloUiTicketCalendar;
